import React from 'react';
import Profile from '../../images/Recommendation-Profile.svg';
import Social from '../../images/Recommendation-Social.svg';
import Title from '../../images/Recommendation-Title.svg';
import About from '../../images/Recommendation-About.svg';
import Education from '../../images/Recommendation-Education.svg';

import EditProfileModal from '../components/_molecules/EditProfileModal';
import EditProfileFieldsBio, { editProfileBioValidationSchema } from '../components/_molecules/EditProfileFieldsBio';
import EditProfileFieldsSocial, {
    editProfileSocialValidationSchema,
} from '../components/_molecules/EditProfileFieldsSocial';
import EditProfileFieldsEmployment, {
    editProfileEmploymentValidationSchema,
} from '../components/_molecules/EditProfileFieldsEmployment';
import EditProfileFieldsEducation, {
    editProfileEducationValidationSchema,
} from '../components/_molecules/EditProfileFieldsEducation/index';
import EditProfilePicture from '../components/_molecules/EditProfilePicture';

export default [
    {
        id: 'image',
        header: 'Add a Profile Picture',
        description: 'Add a profile picture to help fellow members put a face to your name.',
        icon: Profile,
        hash: 'edit-pic',
        modalComponent: (
            <EditProfileModal
                showSubmitButton={false}
                headerText="Add a Profile Picture"
                instructions="Add a profile picture to help fellow members put a face to your name."
                childComponent={<EditProfilePicture />}
                validationSchema={editProfileSocialValidationSchema}
            />
        ),
    },
    {
        id: 'social',
        header: 'Connect to your Social Accounts',
        description: 'Make it easy to connect with members by linking your social accounts.',
        icon: Social,
        hash: 'edit-social',
        modalComponent: (
            <EditProfileModal
                headerText="Connect Your Social Media Accounts"
                instructions="Make it easy to connect with members by linking your social accounts."
                childComponent={<EditProfileFieldsSocial />}
                validationSchema={editProfileSocialValidationSchema}
                submitButtonText="Save Social Media Information"
            />
        ),
    },
    {
        id: 'title',
        header: 'Add Your Title Category',
        description: 'Select a category to improve your findability and network opportunities.',
        icon: Title,
        hash: 'edit-title',
        modalComponent: (
            <EditProfileModal
                headerText="Add Your Title Category"
                instructions="Select a category based on your role to improve your findability and network opportunities."
                childComponent={<EditProfileFieldsEmployment />}
                validationSchema={editProfileEmploymentValidationSchema}
                submitButtonText="Save Your Title Category"
            />
        ),
    },
    {
        id: 'bio',
        header: 'Add an About Statement',
        description: 'Introduce yourself by adding a summary about your expertise and interests.',
        icon: About,
        hash: 'edit-about',
        modalComponent: (
            <EditProfileModal
                headerText="Add Your About Statement"
                instructions="This will appear on your member profile page."
                childComponent={<EditProfileFieldsBio />}
                validationSchema={editProfileBioValidationSchema}
                submitButtonText="Save Your Biography"
            />
        ),
    },
    {
        id: 'education',
        header: 'Add Education Information',
        description: 'Add your college and/or university to expand your networking opportunities',
        icon: Education,
        hash: 'edit-education',
        modalComponent: (
            <EditProfileModal
                headerText="Add Education Information"
                instructions="Add your college and/or university to expand your networking opportunities. Education information is displayed on your member profile page."
                childComponent={<EditProfileFieldsEducation />}
                validationSchema={editProfileEducationValidationSchema}
                submitButtonText="Save Your Education Information"
            />
        ),
    },
];
